import { Group, Table } from '@mantine/core';
import { IconChevronDown, IconChevronUp, IconSelector } from '@tabler/icons-react';

const ProductHeadingColumns = ({ sortProducts, sortFieldsData }) => {
  const columns = [
    { name: 'Id' },
    { name: 'Name' },
    { name: 'Available', sortField: 'available' },
    { name: 'Locale', sortField: 'locale' },
    { name: 'List Price', sortField: 'listPrice' },
    { name: 'Actual', sortField: 'price' },
    { name: '-%', sortField: 'discountPercent' },
    { name: 'Created At', sortField: 'createdAt' },
    { name: 'Updated At', sortField: 'updatedAt' },
    { name: 'View Popularity', sortField: 'popularScoreByProductView' },
    { name: 'Purchase Popularity', sortField: 'popularScoreByCartAdd' },
  ];

  const handleSortProducts = (sortField, currentSortOrder) => {
    let sortOrder = 'asc';

    if (currentSortOrder === 'asc') {
      sortOrder = 'desc';
    }
    if (currentSortOrder === 'desc') {
      sortOrder = '';
    }

    sortProducts(sortField, sortOrder);
  };

  const getSortIcon = (sortOrder) => {
    if (sortOrder === 'asc') {
      return <IconChevronUp size={14} />;
    }
    if (sortOrder === 'desc') {
      return <IconChevronDown size={14} />;
    }
    return <IconSelector size={14} style={{ opacity: 0.3 }} />;
  };

  const columnsEl = columns.map((column, index) => {
    let currentSortOrder = '';

    for (const field of sortFieldsData) {
      if (column.sortField === field.sortField && field.sortOrder !== '') {
        currentSortOrder = field.sortOrder;
      }
    }

    if (column.sortField) {
      return (
        <Table.Th
          key={index}
          style={{ cursor: 'pointer' }}
          onClick={() => handleSortProducts(column.sortField, currentSortOrder)}
        >
          <Group gap={4} wrap="nowrap">
            {column.name}
            {getSortIcon(currentSortOrder)}
          </Group>
        </Table.Th>
      );
    }

    return <Table.Th key={index}>{column.name}</Table.Th>;
  });

  return <Table.Tr>{columnsEl}</Table.Tr>;
};

export default ProductHeadingColumns;
